import { Component, ElementRef, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'app/components/header/header.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { ApplicationService } from 'app/services/application.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmInfoComponent } from '../business-info/confirm-info/confirm-info.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { parseJSON, scrollToFirstInvalidControl } from 'app/shared/utils';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';
import axios from 'axios';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatDividerModule } from '@angular/material/divider';
import { ApplicationStepperComponent } from 'app/components/application-stepper/application-stepper.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-application-document-upload',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        TranslateModule,
        FooterComponent,
        MatIconModule,
        FormsModule,
        LoaderComponent,
        MatExpansionModule,
        MatCardModule,
        SlickCarouselModule,
        MatDividerModule,
        ApplicationStepperComponent,
    ],
    templateUrl: './application-document-upload.component.html',
    styleUrls: ['./application-document-upload.component.scss'],
})
export class ApplicationDocumentUploadComponent {
    isChecked: boolean = false;
    fromResume: boolean = false;
    clickedOutside: boolean = false;
    uploadMandatory: boolean = false;
    bankStatementMandatory: boolean = false;
    isproofOfAddressUploaded: boolean = false;
    isBankStatementUploaded: boolean = false;
    isSSMDocUploaded: boolean = false;
    ssmDocMandatory: boolean = false;
    proofOfAddressMandatory: boolean = false;
    toggleDropDown = [false, false, false, false];
    disableSubmitBtn: boolean = false;
    apiResponse: boolean = true;
    submitted: boolean = false;
    checkboxError: boolean = false;
    isTermsCheck = 0;
    counter = 0;

    productName: string;
    prodCode: any;

    caseId: any;
    ssmResponse: any;
    objectRequested: any;
    productFlowData: any;
    selectedLanguage: any;
    uploadContidionData: any;
    bankStatmentResponse: any;
    proofOfAddressResponse: any;
    @ViewChild('formContainer') formContainer!: ElementRef;
    ACTIVE = 'ACTIVE';
    POA = 'PROOF_OF_ADDRESS';
    SSM = 'SSM_DOC';
    BANK = 'BANK_STATEMENT';

    saveDraft = 0;
    uploadedFile = [];

    draftMsg = '';
    closeTostr = '';
    submitDocError: string;
    docLink: any;

    value = 100;
    isFocus: boolean = false;
    panelOpenState = signal(true);
    currentSlide: number = 0;
    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    rightSide = [
        {
            title: 'RIGHT_DIV.TITLE_1',
            subtitle: 'RIGHT_DIV.SUBTITLE_1',
        },
        {
            title: 'RIGHT_DIV.TITLE_2',
            subtitle: 'RIGHT_DIV.SUBTITLE_2',
        },
        {
            title: 'RIGHT_DIV.TITLE_3',
            subtitle: 'RIGHT_DIV.SUBTITLE_3',
        },
    ];

    constructor(
        private router: Router,
        public dialog: MatDialog,
        private translate: TranslateService,
        private applicationService: ApplicationService,
        private toastr: ToastrService
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.productName =
            this.router.getCurrentNavigation().extras.state?.productName;
        // If resume journey from draft page
        this.caseId = this.router.getCurrentNavigation().extras.state?.caseId;
        if (!this.caseId) {
            //forwarded from apply product
            this.caseId =
                this.router.getCurrentNavigation().extras.state?.productFlowData?.caseId;
        }
        this.applicationService.checkCaseIdForRedirection(this.caseId);

        this.objectRequested =
            this.router.getCurrentNavigation().extras.state?.objectRequested;
        this.uploadContidionData =
            this.router.getCurrentNavigation().extras.state?.docsCondition;
        this.fromResume =
            this.router.getCurrentNavigation().extras.state?.fromResume;

        this.productFlowData =
            this.router.getCurrentNavigation().extras.state?.productFlowData;
    }

    ngOnInit() {
        this.getTranslation();
        if (typeof this.uploadContidionData === 'string') {
            let uploadDocs = this.parseStringToJson(this.uploadContidionData);
            if (uploadDocs?.BANK_STATEMENT == 'Y') {
                this.bankStatementMandatory = true;
                this.uploadMandatory = true;
            }
            if (uploadDocs?.SSM_DOC == 'Y') {
                this.ssmDocMandatory = true;
                this.uploadMandatory = true;
            }
            if (uploadDocs?.PROOF_OF_ADDRESS == 'Y') {
                this.proofOfAddressMandatory = true;
                this.uploadMandatory = true;
            }
        } else if (this.uploadContidionData?.length > 0) {
            this.uploadContidionData.some((x: any) => {
                if (x.uploadDocs !== null) {
                    x.uploadDocs = this.parseStringToJson(x.uploadDocs);
                    if (x.uploadDocs?.BANK_STATEMENT == 'Y') {
                        this.bankStatementMandatory = true;
                        this.uploadMandatory = true;
                    }
                    if (x.uploadDocs?.SSM_DOC == 'Y') {
                        this.ssmDocMandatory = true;
                        this.uploadMandatory = true;
                    }
                    if (x.uploadDocs?.PROOF_OF_ADDRESS == 'Y') {
                        this.proofOfAddressMandatory = true;
                        this.uploadMandatory = true;
                    }
                }
            });
        }

        this.getCaseDetails(this.caseId).then((data) => {
            if (data.docCheckBox) {
                this.isTermsCheck = 1;
                this.isChecked = true;
            } else {
                this.isTermsCheck = 0;
                this.isChecked = false;
            }

            if (data.prodSelectionList && data.prodSelectionList.length) {
                this.prodCode = data.prodSelectionList[0].prodCode;
            }

            let isSaveDraft = 1;
            if (data)
                this.uploadDocuments(
                    this.isTermsCheck,
                    this.caseId,
                    isSaveDraft,
                    false
                );
        });
    }

    parseStringToJson(str: string): { [key: string]: any } {
        const result: { [key: string]: any } = {};
        // Split by comma to get key-value pairs
        const pairs = str.split(',');
        pairs.forEach((pair) => {
            const [key, value] = pair.split(':').map((s) => s.trim()); // Split by colon and trim spaces
            result[key] = value;
        });
        return result;
    }

    async getCaseDetails(caseId: string) {
        const value = await this.applicationService
            .getCaseDetails(caseId)
            .toPromise();
        return value[0];
    }

    switchLanguageHandler(data: any) {
        this.selectedLanguage = data;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    closeDropdown() {
        for (let i = 0; i < 4; i++) {
            this.toggleDropDown[i] = false;
        }
    }

    onUploadSelectedFile(event, type, el) {
        let file: File = event.target.files[0];
        if (el == 1) {
            this.isBankStatementUploaded = true;
        } else if (el == 2) {
            this.isSSMDocUploaded = true;
        } else if (el == 3) {
            this.isproofOfAddressUploaded = true;
        }

        let data = {};

        if (file.type == 'application/pdf') {
            this.isPDFPasswordProtected(file, true, null)
                .then(async (isProtected) => {
                    if (isProtected) {
                        let password = '';
                        if (this.readLocalStorageValue('language') == 'bm') {
                            password = prompt(
                                'Sila masukkan kata laluan untuk fail anda'
                            );
                        } else {
                            password = prompt(
                                'Please enter the password for the file'
                            );
                        }

                        if (!password) {
                            if (
                                this.readLocalStorageValue('language') == 'bm'
                            ) {
                                alert(
                                    'Kata laluan diperlukan untuk memuat naik fail anda.'
                                );
                            } else {
                                alert(
                                    'Password is required to upload your file.'
                                );
                            }

                            event.target.value = null;
                            file = event.target.value;
                            return;
                        }

                        if (password) {
                            this.checkPassword(file, password)
                                .then(async (isCorrect) => {
                                    if (isCorrect) {
                                        data = {
                                            file,
                                            type,
                                            password,
                                        };
                                        this.uploadedFile.push(data);
                                        if (data) {
                                            this.uploadDocuments(
                                                this.isTermsCheck,
                                                this.objectRequested?.caseId,
                                                this.saveDraft,
                                                file,
                                                type,
                                                true,
                                                password
                                            );
                                            this.apiResponse = false;
                                        }
                                    }
                                    event.target.value = null;
                                    file = event.target.value;
                                })
                                .catch((error) => {
                                    this.snackBarFunct(error.message, 'error');
                                });
                        }
                    } else {
                        data = {
                            file,
                            type,
                        };

                        this.uploadedFile.push(data);
                        if (file) {
                            this.uploadDocuments(
                                this.isTermsCheck,
                                this.objectRequested?.caseId,
                                this.saveDraft,
                                file,
                                type,
                                true
                            );
                            this.apiResponse = false;
                            event.target.value = null;
                            file = event.target.value;
                        }
                    }
                })
                .catch((error) => {
                    alert('An error occurred while checking the PDF file.');
                });
        } else {
            //Other than PDF
            if (file) {
                //file
                this.uploadDocuments(
                    this.isTermsCheck,
                    this.objectRequested?.caseId,
                    this.saveDraft,
                    file,
                    type,
                    true
                );
                this.apiResponse = false;
                event.target.value = null;
                file = event.target.value;
            }
        }
    }

    async isPDFPasswordProtected(
        file: File,
        fromUpload?: boolean,
        url?: string
    ): Promise<boolean> {
        if (fromUpload) {
            try {
                // Read the file as an ArrayBuffer
                const fileBuffer = await file.arrayBuffer();

                // Try to load the PDF document
                const pdfDoc = await PDFDocument.load(fileBuffer, {
                    ignoreEncryption: true,
                });

                // If the document loads successfully, it's not password-protected
                return pdfDoc.isEncrypted;
            } catch (error) {
                // Check if the error is due to encryption or other reasons
                if (
                    error.message.includes(
                        'This PDF is encrypted and requires a password to open'
                    )
                ) {
                    console.error('The PDF is encrypted:', error);
                    return true;
                } else if (
                    error.message.includes('Trying to parse invalid object')
                ) {
                    console.error('Invalid PDF object structure:', error);
                } else {
                    console.error(
                        'Unexpected error occurred while processing the PDF:',
                        error
                    );
                }
                return true;
            }
        } else {
            try {
                pdfjsLib.GlobalWorkerOptions.workerSrc =
                    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/5.4.54/pdf.worker.min.mjs';

                // Attempt to load the PDF document
                const loadingTask = pdfjsLib.getDocument(url);
                const pdfDocument = await loadingTask.promise;

                // If we successfully loaded the document, it does not require a password
                return false;
            } catch (error) {
                // Check if the error is related to password protection
                if (error && error.name === 'PasswordException') {
                    return true; // PDF is password-protected
                }
                console.error('Error loading PDF:', error);
                return false; // Other errors might not be password-related
            }
        }
    }

    async checkPassword(file: File, password: any): Promise<boolean> {
        try {
            this.apiResponse = false;
            let status = false;
            pdfjsLib.GlobalWorkerOptions.workerSrc =
                'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/5.4.54/pdf.worker.min.mjs';
            const fileBuffer = await file.arrayBuffer();
            const loadingTask = pdfjsLib.getDocument({
                data: fileBuffer,
                password: password,
            });
            let result = await loadingTask.promise.then(
                (pdfDoc) => {
                    this.apiResponse = true;
                    return (status = true);
                },
                (error) => {
                    if (error?.name == 'PasswordException') {
                        if (localStorage.getItem('language') == 'bm') {
                            this.snackBarFunct(
                                `Kata laluan fail tidak sah. Sila cuba lagi.`,
                                `error`
                            );
                        } else {
                            this.snackBarFunct(
                                'Incorrect password. Please try again.',
                                `error`
                            );
                        }
                    } else {
                        this.snackBarFunct(error.message, 'error');
                    }
                    this.apiResponse = true;
                    return (status = false);
                }
            );
            return result;
        } catch (error) {
            this.snackBarFunct(error.message, 'error');
            return false;
        }
    }

    uploadDocuments(
        isTermsCheck,
        caseId,
        draftId,
        data?,
        type?,
        onClickUploadBtn?,
        password?
    ) {
        this.applicationService
            .uploadDocument(isTermsCheck, caseId, draftId, data, type, password)
            .subscribe({
                next: (res: any) => {
                    this.apiResponse = true;
                    let data = res;
                    if (onClickUploadBtn == true) {
                        if (data && data.length) {
                            this.counter = this.counter + 1;
                            const result = data?.reduce((x, y) => {
                                (x[y.alias] = x[y.alias] || []).push(y);
                                return x;
                            }, {});
                            this.bankStatmentResponse = result?.BANK_STATEMENT;
                            this.ssmResponse = result?.SSM_DOC;
                            this.proofOfAddressResponse =
                                result?.PROOF_OF_ADDRESS;

                            if (data.length < this.counter) {
                                this.counter = this.counter - 1;
                                this.corruptedFileErrorMsg();
                            }
                        } else {
                            this.corruptedFileErrorMsg();
                        }
                    } else {
                        // FROM RESUME
                        if (data && data.length) {
                            this.counter = data.length;
                            const result = data?.reduce((x, y) => {
                                (x[y.alias] = x[y.alias] || []).push(y);
                                return x;
                            }, {});
                            this.bankStatmentResponse = result?.BANK_STATEMENT;
                            if (this.bankStatmentResponse) {
                                this.isBankStatementUploaded = true;
                            }
                            this.ssmResponse = result?.SSM_DOC;
                            if (this.ssmResponse) {
                                this.isSSMDocUploaded = true;
                            }
                            this.proofOfAddressResponse =
                                result?.PROOF_OF_ADDRESS;
                            if (this.proofOfAddressResponse) {
                                this.isproofOfAddressUploaded = true;
                            }
                        }
                    }
                },
                error: (err: any) => {
                    this.apiResponse = true;
                    if (err?.error?.message == `Validation errors`) {
                        if (localStorage.getItem('language') == 'bm') {
                            this.snackBarFunct(
                                `Jenis fail mestilah: pdf, jpeg, jpg, png.`,
                                `error`
                            );
                        } else {
                            this.snackBarFunct(
                                `The file must be a file of type: pdf, jpeg, jpg, png.`,
                                `error`
                            );
                        }
                    } else if (err?.status == 0) {
                        if (localStorage.getItem('language') == 'bm') {
                            this.snackBarFunct(
                                `Fail mestilah tidak melebihi 10 MB.`,
                                `error`
                            );
                        } else {
                            this.snackBarFunct(
                                `The file must not be greater than 10 MB.`,
                                `error`
                            );
                        }
                    }
                },
            });
    }

    corruptedFileErrorMsg() {
        let msg;
        if (localStorage.getItem('language') == 'bm') {
            msg = this.snackBarFunct(
                `Fail tidak dapat dibaca. Sila muat naik fail lain.`,
                `error`
            );
        } else {
            msg = this.snackBarFunct(
                `File is corrupted. Please upload another file.`,
                `error`
            );
        }

        return msg;
    }

    deleteDocument(docsId: string, caseId: string, el: any) {
        if (el == 1) {
            this.isBankStatementUploaded = false;
        } else if (el == 2) {
            this.isSSMDocUploaded = false;
        } else if (el == 3) {
            this.isproofOfAddressUploaded = false;
        }

        let data = {
            productFlowData: {
                prodCode: this.prodCode,
                type: 'delete_document',
            },
        };
        let dRef = this.dialog.open(ConfirmInfoComponent, {
            backdropClass: 'confirminfo-dialog-background',
            hasBackdrop: true,
            scrollStrategy: new NoopScrollStrategy(),
            panelClass: 'confirminfo-custom-dialog',
            data,
            disableClose: true,
        });
        dRef.afterClosed().subscribe((res) => {
            if (res.data == 'submit') {
                this.applicationService
                    .deleteDocument(docsId, caseId)
                    .subscribe({
                        next: (res: any) => {
                            const data = res;
                            this.counter = this.counter - 1;
                            if (data?.alias == 'BANK_STATEMENT') {
                                this.bankStatmentResponse =
                                    this.bankStatmentResponse?.filter(
                                        (item) => item?.docsId !== res?.id
                                    );
                            } else if (data?.alias == 'SSM_DOC') {
                                this.ssmResponse = this.ssmResponse?.filter(
                                    (item) => item?.docsId !== res?.id
                                );
                            } else {
                                this.proofOfAddressResponse =
                                    this.proofOfAddressResponse?.filter(
                                        (item) => item?.docsId !== res?.id
                                    );
                            }
                        },
                        error: (err: any) => {
                            if (
                                err?.error?.message == `Delete By id not found`
                            ) {
                                if (localStorage.getItem('language') == 'bm') {
                                    this.snackBarFunct(
                                        `Padam Mengikut id tidak ditemui`,
                                        `error`
                                    );
                                } else {
                                    this.snackBarFunct(
                                        err?.error?.message,
                                        `error`
                                    );
                                }
                            }
                        },
                    });
            }
        });
    }

    snackBarFunct(message: string, type: 'success' | 'error') {
        const types = {
            success: () => this.toastr.success(message),
            error: () => this.toastr.error(message),
        };

        if (types[type]) {
            return types[type](); // call the appropriate toastr method
        }
    }

    checkChecked() {
        if (this.isChecked == false) {
            this.isChecked = true;
            this.isTermsCheck = 1;
            this.checkboxError = false;
        } else {
            this.isChecked = false;
            this.isTermsCheck = 0;
            this.checkboxError = true;
        }
    }

    getTranslation() {
        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.translate
            .get('NEW_APPLICATION.DOCUMENT_UPLOAD.SUBTITLE_MANDATORY')
            .subscribe((data: any) => {
                this.submitDocError = data;
            });

        this.translate
            .get('NEW_APPLICATION.DOCUMENT_UPLOAD.UPLOAD_DOC_SAVE_DRAFT_MSG')
            .subscribe((data: any) => {
                this.draftMsg = data;
            });
    }

    submitApplication() {
        this.getTranslation();
        this.submitted = true;
        scrollToFirstInvalidControl(this.formContainer.nativeElement);
        if (this.isChecked) {
            if (this.uploadMandatory) {
                if (
                    this.bankStatementMandatory &&
                    (this.bankStatmentResponse == undefined ||
                        this.bankStatmentResponse.length == 0 ||
                        !this.bankStatmentResponse)
                ) {
                    this.toastr.error(this.submitDocError);
                } else if (
                    this.ssmDocMandatory &&
                    (this.ssmResponse == undefined ||
                        this.ssmResponse.length == 0 ||
                        !this.ssmResponse)
                ) {
                    this.toastr.error(this.submitDocError);
                } else if (
                    this.proofOfAddressMandatory &&
                    (this.proofOfAddressResponse == undefined ||
                        this.proofOfAddressResponse.length == 0 ||
                        !this.proofOfAddressResponse)
                ) {
                    this.toastr.error(this.submitDocError);
                } else if (
                    (this.bankStatementMandatory &&
                        this.bankStatmentResponse.length > 0) ||
                    (this.ssmDocMandatory && this.ssmResponse.length > 0) ||
                    (this.proofOfAddressMandatory &&
                        this.proofOfAddressResponse.length > 0)
                ) {
                    this.disableSubmitBtn = true;
                    this.apiResponse = false;
                    this.objectRequested['docCheckBox'] = this.isTermsCheck;
                    this.applicationService
                        .submission(this.objectRequested)
                        .subscribe({
                            next: (res) => {
                                this.apiResponse = true;
                                let submissionData = parseJSON(res);
                                this.router.navigate(['/status'], {
                                    state: {
                                        submissionDetails: submissionData,
                                        caseId: this.caseId,
                                        prodCode: this.prodCode,
                                    },
                                });
                            },
                            error: (err) => {
                                this.apiResponse = true;
                                this.disableSubmitBtn = false;
                                this.toastr.error(err.error.message);
                            },
                        });
                }
            } else {
                if (
                    this.bankStatmentResponse == undefined ||
                    this.bankStatmentResponse.length == 0 ||
                    this.ssmResponse == undefined ||
                    this.ssmResponse.length == 0 ||
                    this.proofOfAddressResponse == undefined ||
                    this.proofOfAddressResponse.length == 0 ||
                    (!this.bankStatmentResponse &&
                        !this.ssmResponse &&
                        !this.proofOfAddressResponse)
                ) {
                    let data = {
                        productFlowData: {
                            prodCode: this.prodCode,
                            type: 'submit_wo_document',
                        },
                    };
                    let dRef = this.dialog.open(ConfirmInfoComponent, {
                        backdropClass: 'confirminfo-dialog-background',
                        hasBackdrop: true,
                        scrollStrategy: new NoopScrollStrategy(),
                        panelClass: 'confirminfo-custom-dialog',
                        data,
                        disableClose: true,
                    });
                    dRef.afterClosed().subscribe((res) => {
                        if (res?.data == 'submit') {
                            this.disableSubmitBtn = true;
                            this.apiResponse = false;
                            this.objectRequested['docCheckBox'] =
                                this.isTermsCheck;
                            this.applicationService
                                .submission(this.objectRequested)
                                .subscribe({
                                    next: (res) => {
                                        this.apiResponse = true;
                                        let submissionData = parseJSON(res);
                                        this.router.navigate(['/status'], {
                                            state: {
                                                submissionDetails:
                                                    submissionData,
                                                caseId: this.caseId,
                                                prodCode: this.prodCode,
                                            },
                                        });
                                    },
                                    error: (err) => {
                                        this.apiResponse = true;
                                        this.disableSubmitBtn = false;
                                        this.toastr.error(err.error.message);
                                    },
                                });
                        } else {
                            this.disableSubmitBtn = false;
                        }
                    });
                } else if (
                    this.bankStatmentResponse &&
                    this.ssmResponse &&
                    this.proofOfAddressResponse
                ) {
                    this.disableSubmitBtn = true;
                    this.apiResponse = false;
                    this.objectRequested['docCheckBox'] = this.isTermsCheck;
                    this.applicationService
                        .submission(this.objectRequested)
                        .subscribe({
                            next: (res) => {
                                this.apiResponse = true;
                                let submissionData = parseJSON(res);
                                this.router.navigate(['/status'], {
                                    state: {
                                        submissionDetails: submissionData,
                                        caseId: this.caseId,
                                        prodCode: this.prodCode,
                                    },
                                });
                            },
                            error: (err) => {
                                this.apiResponse = true;
                                this.disableSubmitBtn = false;
                                this.toastr.error(err.error.message);
                            },
                        });
                }
            }
        } else {
            this.disableSubmitBtn = false;
            this.checkboxError = true;
        }
    }

    saveApplicationAsDraft() {
        this.disableSubmitBtn = true;
        this.saveDraft = 1;
        this.getTranslation();
        this.applicationService
            .uploadDocument(
                this.isTermsCheck,
                this.objectRequested?.caseId,
                this.saveDraft
            )
            .subscribe({
                next: (res: any) => {
                    this.disableSubmitBtn = false;
                    this.toastr.success(this.draftMsg);
                },
                error: (err: any) => {},
            });
    }

    readLocalStorageValue(key) {
        let value = localStorage.getItem(key);
        return value;
    }

    viewORdownloadDocs(docId: any, fileName?: any) {
        let data = {
            caseId: this.caseId,
            docsId: docId,
            // docType: this.getDocumentType(fileName),
        };

        this.applicationService.viewDocument(data).subscribe({
            next: (res: any) => {
                this.docLink = res?.URL;
                this.isPDFPasswordProtected(null, false, this.docLink)
                    .then(async (requiresPassword) => {
                        if (requiresPassword) {
                            let password = '';
                            if (
                                this.readLocalStorageValue('language') == 'bm'
                            ) {
                                password = prompt(
                                    'Sila masukkan kata laluan untuk fail anda'
                                );
                            } else {
                                password = prompt(
                                    'Please enter the password for the file'
                                );
                            }

                            if (password) {
                                const response = await axios.get(this.docLink, {
                                    responseType: 'arraybuffer',
                                });
                                const loadingTask = pdfjsLib.getDocument({
                                    data: response.data,
                                    password,
                                });
                                const pdfDoc = await loadingTask.promise;
                                const pdfBytes = await pdfDoc.saveDocument();
                                const safeBytes = new Uint8Array(pdfBytes);
                                const pdfBlob = new Blob([safeBytes], {
                                    type: 'application/pdf',
                                });
                                const pdfUrl = URL.createObjectURL(pdfBlob);
                                window.open(pdfUrl, '_blank');
                            }

                            if (!password) {
                                if (
                                    this.readLocalStorageValue('language') ==
                                    'bm'
                                ) {
                                    alert(
                                        'Kata laluan diperlukan untuk melihat fail.'
                                    );
                                } else {
                                    alert(
                                        'Password is required to view the file.'
                                    );
                                }
                                return;
                            }
                        } else {
                            window.open(this.docLink, '_blank');
                        }
                    })
                    .catch((error) => {
                        if (error?.name == 'PasswordException') {
                            if (localStorage.getItem('language') == 'bm') {
                                this.snackBarFunct(
                                    `Kata laluan fail tidak sah. Sila cuba lagi.`,
                                    `error`
                                );
                            } else {
                                this.snackBarFunct(
                                    'Incorrect password. Please try again.',
                                    `error`
                                );
                            }
                        } else {
                            this.snackBarFunct(error.message, 'error');
                        }
                    });
            },
            error: (err: any) => {
                if (err?.error?.message == `Document id is missing`) {
                    if (localStorage.getItem('language') == 'bm') {
                        this.snackBarFunct(`ID dokumen tiada`, `error`);
                    } else {
                        this.snackBarFunct(err?.error?.message, `error`);
                    }
                } else if (
                    err?.error?.message ==
                    `Invalid id or input id is not related to logged-in user or status is Deactive`
                ) {
                    if (localStorage.getItem('language') == 'bm') {
                        this.snackBarFunct(
                            `Id atau id input tidak sah tidak berkaitan dengan pengguna log masuk atau statusnya Deaktif`,
                            `error`
                        );
                    } else {
                        this.snackBarFunct(err?.error?.message, `error`);
                    }
                }
            },
        });
    }

    getDocumentType(fileName: any) {
        if (fileName) {
            let splittedFN = fileName.split('.');
            return splittedFN.at(-1);
        }
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }
}
